import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LogonComponent } from './components/logon/logon.component';
import { AuthService } from './CookieAuth/auth.service';
import { AppService } from './service/app.service';
import { PermisoService } from './service/permiso.service';
import { TestService } from './service/test.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  public navbarVisible='';
  cookieValue: string = "";
  idUsr:number=0;
  permitido:boolean=false;
  public permiso?:any[];
  public apps?:any[];
  public direcciones?:any[];
  constructor(private cookie: AuthService, private test: TestService, private permisos: PermisoService, private app: AppService,private dialog: MatDialog) {
    if(window.location.pathname==='/login' || window.location.pathname.substring(0,8)==='/cliente'||window.location.pathname==='/main'||window.location.pathname==='/' || window.location.pathname.substring(0,8)==='/activar'|| window.location.pathname==='/miusuario'){
      console.log('permitido por defecto')
      this.permitido=true;
    }
    // console.log(window.location.pathname.substring(0,7));


    this.cookieValue= this.cookie.getCookie();
    this.direcciones=new Array();
    this.permiso=new Array();
    this.app.get().subscribe((app: any) => {
      this.apps = app;
      // console.log('apps');
      // console.log(this.apps);
      this.permisos.get(this.cookieValue).subscribe((data: any[]) => {
        this.permiso = data;
        // console.log('permisos cargados');
        // console.log(this.permiso);
        this.permiso.forEach(element => {
          let algo = this.apps?.filter(app => app.id === element.id_app)[0];
          // this.permiso=element

          this.direcciones?.push(algo);
          if (window.location.pathname === '/'+algo.direccion) {
            console.log('permitido por ' + algo.descripcion);
            this.permitido = true;
          }
        });
        // console.log('permisos' + this.permitido);
        // console.log(this.direcciones);


        if (!this.permitido) {
          window.location.href = "/";
        }

      });
    });
    // if (!this.permitido) {
    //   window.location.href = "/";
    // }
    // console.log('Router.name')
    // console.log(window.location.pathname)




   }

  public ngOnInit() {

  }
navbarVer(){
  if(this.navbarVisible===''){
    this.navbarVisible='show';
  }else{
    this.navbarVisible='';
  }
}
  cerrarSession(){
    this.cookie.deleteCookie();
    window.location.href = "/";

  }
  verUser(){
    window.location.href = "miusuario";
  }
  nuevoUsuario(){
    let dialogRef = this.dialog.open(LogonComponent, {
      data: {id: 0},
      maxHeight: '90vh'
    });
  }
  title = 'front';
}
